<template>
  <a-modal
    :visible="visible"
    width="702px"
    :mask-closable="false"
    title="当前使用协议"
    :confirm-loading="btnIsLoading"
    @ok="$emit('handleSubmit')"
    @cancel="$emit('onCancel')"
  >
    <basic-form
      ref="basicForm"
      :form-data="formData1"
    >
      <template #id>
        <a-select
          v-decorator="[
            'id',
            { rules: [{ required: true, message: '请选择当前使用的协议' }] },
          ]"
          placeholder="请选择当前使用的协议"
        >
          <a-select-option
            v-for="item in agreementData"
            :key="item.id"
            :value="item.id"
          >
            {{ item.title }}
          </a-select-option>
        </a-select>
      </template>
    </basic-form>
  </a-modal>
</template>
<script>
import { formData1 } from '../data/index';
export default {
  props: ['visible', 'btnIsLoading'],
  data() {
    return {
      formData1,
      agreementData: [],
    };
  },
  mounted() {
    // 获取表格数据
    this.getAgreementData({
      page: 0,
      pageSize: 0,
    });
  },

  methods: {
    async getAgreementData(params) {
      let result = await this.$http.post(
        '/AgreementDoc/getList',
        params,
      );
      if (result.data.status === 1) {
        this.agreementData=result.data.data.data_list.filter((item)=>item.status!==0);
        console.log('TCL: getAgreementData -> this.agreementData', this.agreementData);
      }},
  },
};
</script>
<style lang="scss" scoped>
.client-modal-wrapper {
  .textarea {
    font-size: 12px;
    font-weight: 400;
    color: rgba(86, 92, 102, 1);
    position: relative;
    top: -37px;
    right: -550px;
  }
}
</style>
